import { Component, Input, OnInit, Renderer2 } from '@angular/core';

@Component({
    selector: 'app-user-profile-menu',
    templateUrl: './user-profile-menu.component.html',
    styleUrls: ['./user-profile-menu.component.scss']
})
export class UserProfileMenuComponent implements OnInit {
    @Input() color = 'inherit';
    @Input() username = '';
    @Input() panelStyleClass = '';
    @Input() loggedIn = false;

    menuVisible = false;
    preventDocumentDefault: any;
    documentClickListener: any;

    constructor(private renderer: Renderer2) {
    }

    ngOnInit() {
        this.documentClickListener = this.renderer.listen('document', 'click', () => {
            if (!this.preventDocumentDefault) {
                this.menuVisible = false;
            }
            this.preventDocumentDefault = false;
        });
    }

    onToggleMenu(event: Event) {
        this.menuVisible = !this.menuVisible;
        this.preventDocumentDefault = true;
        event.preventDefault();
    }

    getStyleClass() {
        return { 'topbar-menu-visible': this.menuVisible, [this.panelStyleClass]: !!this.panelStyleClass };
    }
}
